export default __webpack_public_path__ + "CircularCustCapNum-Medium.da8c62f41cc45ae36a28ae1c447e0eb8.ttf";